import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/dialpad-ai.vue
var s = {
	name: "DtIconDialpadAi",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--dialpad-ai"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Dialpad Ai",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M10.721 2.916a.958.958 0 1 0 0-1.916.958.958 0 0 0 0 1.916Z" }, null, -1), i("path", {
		"fill-rule": "evenodd",
		d: "M4.591 2.694c-.217 0-.59.207-.785.841v.002L1.964 9.473a.749.749 0 0 1-1.43-.444l1.84-5.932v-.002c.3-.975 1.084-1.899 2.217-1.899s1.916.922 2.216 1.896l1.417 4.57c.195.633.568.84.785.84a.963.963 0 0 0 .963-.963V4.411a.749.749 0 1 1 1.498 0v3.128A2.46 2.46 0 0 1 9.01 10c-1.132 0-1.916-.92-2.216-1.895l-1.418-4.57c-.195-.633-.567-.84-.785-.84Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=dialpad-ai.js.map